<template>
  <el-container>
    <el-header>
      客户查询
      <el-divider></el-divider>
    </el-header>
    <el-main>
      <div class="main">
        <div class="button-add">
          <el-button size="small" type="primary" @click="handleAddClick">新增</el-button>
        </div>
        <div class="search">
          <el-input
            v-model="search"
            size="small"
            @keyup.enter.native="find"
            @submit.native.prevent
            placeholder="输入客户名称"
            style="width: 80%;margin-right: 4px"/>
          <el-button
            size="mini"
            style="height:32px;width: 19%;padding: 2px"
            @click="find">查询
          </el-button>
        </div>
      </div>

      <el-table
        v-loading="loading"
        :data="tableData"
        border
        fit
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          max-width="170">
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          min-width="250">
        </el-table-column>

        <el-table-column
          v-if="userRole"
          prop="customerAddress"
          label="客户地址"
          min-width="260">
        </el-table-column>
        <el-table-column
          v-if="userRole"
          prop="customerContacts"
          label="客户联系人"
          width="140">
        </el-table-column>
        <el-table-column
          v-if="userRole"
          prop="customerPhone"
          label="联系电话"
          width="140">
        </el-table-column>

        <el-table-column
          prop="reportTime"
          label="报备时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="reportCompany"
          label="报备公司"
          width="250">
        </el-table-column>
        <el-table-column
          prop="reportName"
          label="报备人"
          min-width="185">
        </el-table-column>

        <el-table-column
          prop="status"
          label="状态"
          min-width="110">
        </el-table-column>
        <el-table-column
          v-if="userRole"
          prop="notes"
          label="备注"
          width="200">
        </el-table-column>
        <el-table-column
          v-if="userRole"
          prop="customerAttribute"
          label="客户属性">
        </el-table-column>

        <el-table-column
          v-if="userRole"
          prop="evidence"
          label="交易凭证"
          min-width="100">
          <template slot-scope="scope">
            <img v-if="scope.row.evidence1" :src="scope.row.evidence1" alt="暂无图片" style="width: 30px; height: 30px;"
                 @click="handlePictureCardPreview(scope.row.evidence1)">
            <img v-if="scope.row.evidence2" :src="scope.row.evidence2" alt="暂无图片" style="width: 30px; height: 30px;"
                 @click="handlePictureCardPreview(scope.row.evidence2)">
            <img v-if="scope.row.evidence3" :src="scope.row.evidence3" alt="暂无图片" style="width: 30px; height: 30px;"
                 @click="handlePictureCardPreview(scope.row.evidence3)">
          </template>
        </el-table-column>

        <el-table-column
          v-if="userRole"
          fixed="right"
          label="操作"
          :width="handleWidth">
          <template slot-scope="scope">
            <el-button @click="handleUpdate(scope.row)" type="text" size="small"
                       style="margin-bottom: 1px;padding: 1px">编辑
            </el-button>
            <el-button @click="open(scope.row)" type="text" size="small"
                       style="margin-bottom: 1px;padding: 1px">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--查看大图-->
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>

      <!--修改信息 表单-->
      <el-dialog title="修改用户信息" :visible.sync="dialogFormVisible" @close="closeDialog">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" :label-position="labelPosition">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="form.customerName" placeholder="请填写客户公司全称" disabled></el-input>
          </el-form-item>
          <el-form-item label="客户联系人" prop="customerContacts">
            <el-input v-model="form.customerContacts" placeholder="请填写客户联系人"></el-input>
          </el-form-item>
          <el-form-item label="客户地址" prop="customerAddress">
            <el-input v-model="form.customerAddress" placeholder="请填写客户地址"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="customerPhone">
            <el-input v-model="form.customerPhone" placeholder="请填写联系电话"></el-input>
          </el-form-item>
          <el-form-item label="报备时间" prop="reportTime">
            <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="form.reportTime"
                            style="width: 100%;"></el-date-picker>
            <!--          <el-input type="date" v-model="form.reportTime"></el-input>-->
          </el-form-item>
          <el-form-item label="报备人+手机号" prop="reportName">
            <el-input v-model="form.reportName" placeholder="如：张三 123677"></el-input>
          </el-form-item>
          <el-form-item label="报备公司" prop="reportCompany">
            <el-input v-model="form.reportCompany" placeholder="请填写报备公司"></el-input>
          </el-form-item>
          <el-form-item label="客户属性" prop="customerAttribute">
            <el-input v-model="form.customerAttribute" placeholder="请填写是否为新客户"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="notes">
            <el-input type="textarea" v-model="form.notes"></el-input>
          </el-form-item>
          <el-form-item label="交易凭证" prop="evidence">
            <img v-if="form.evidence1" :src="form.evidence1" alt="暂无图片" style="width: 50px; height: 50px;"
                 @click="handlePictureCardPreview(form.evidence1)">
            <img v-if="form.evidence2" :src="form.evidence2" alt="暂无图片" style="width: 50px; height: 50px;"
                 @click="handlePictureCardPreview(form.evidence2)">
            <img v-if="form.evidence3" :src="form.evidence3" alt="暂无图片" style="width: 50px; height: 50px;"
                 @click="handlePictureCardPreview(form.evidence3)">

            <el-upload
              ref="upload"
              accept="image/jpeg,image/png,image/jpg"
              action="https://yuanteng.tech:8081/file/upload"
              :on-preview="handlePicturePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :before-upload="beforeEvidenceUpload"
              :on-success="handleEvidenceSuccess"
              multiple
              :limit="3"
              :on-exceed="handleExceed">
              <el-button size="small" type="primary">点击更换交易凭证</el-button>
            </el-upload>

          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close">取 消</el-button>
          <el-button size="small" type="primary" @click="handleSubmit('form')">提 交</el-button>
        </div>
      </el-dialog>


      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="customerCount">
        </el-pagination>
      </div>
      <div class="pagination2">
        <el-pagination
          small
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="size"
          layout=" total,prev, pager, next"
          :total="customerCount">
        </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "FindCustomer",
  data() {
    return {
      uploadToken: {
        token: (JSON.parse(window.localStorage.getItem("access-admin"))).token//携带token
      },
      dialogImageUrl: '',
      dialogVisible: false,
      labelPosition: 'right',
      handleWidth: 92,
      tableData: [],
      search: '',
      currentPage: 1,
      customerCount: 0,
      size: 10,
      user: '',
      form: {},
      dialogFormVisible: false,
      rules: {
        customerName: [
          {required: true, message: '请输入客户名称', trigger: 'blur'},
        ],
        customerContacts: [
          {required: true, message: '请输入客户联系人', trigger: 'blur'},
        ],
        customerAddress: [
          {required: true, message: '请输入客户地址', trigger: 'blur'},
        ],
        customerPhone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
        ],
        reportName: [
          {required: true, message: '请输入报备人+手机号', trigger: 'blur'},
        ],
        reportCompany: [
          {required: true, message: '请输入报备公司', trigger: 'blur'},
        ],
        reportTime: [
          {required: true, message: '请选择报备时间', trigger: 'blur'},
        ],
      },
      loading: false,
      userRole: false
    }
  },
  methods: {
    /**
     * 新增
     */
    handleAddClick() {
      this.$router.push({
        name: 'add',
        params: {
          back: '/index/findCustomer'
        }
      });
    },
    /**
     * 查询客户数据及条数
     */
    findCustomerCount() {
      this.$http.get("https://yuanteng.tech:8081/customer/findCountByCustomerName?customerName=" + this.search + "&username=" + decodeURIComponent(window.atob(this.user.username))).then(res => {
        if (!res.data.status) {
          this.$message.error(res.data.msg);
        } else {
          this.customerCount = res.data.data;
          if (this.customerCount == 0) {
            this.$message.warning('未查询到任何数据');
            this.tableData = [];
          } else {
            this.findCustomer();
          }
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * 查询客户数据
     * @param page  当前页数
     * @param size  每页数量
     */
    findCustomer(page, size) {
      page = page == 1 ? 1 : this.currentPage;
      size = size == 10 ? 10 : this.size;
      this.$http.get("https://yuanteng.tech:8081/customer/findByCustomerName?customerName=" + this.search + "&username=" + decodeURIComponent(window.atob(this.user.username)) + "&currentPage=" + page + "&sizePage=" + size).then(res => {
        if (!res.data.status) {
          this.$message.error(res.data.msg);
          return;
        }
        this.tableData = res.data.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * 搜索框内容查询
     */
    find() {
      if (this.search == '') {
        this.$message({
          message: '请输入内容',
          type: 'warning'
        });
      } else {
        this.loading = true;
        this.findCustomerCount();
      }
    },
    /**
     * 监测每页数量变化
     * @param val
     */
    handleSizeChange(val) {
      this.size = val;
      this.findCustomerCount();
      // console.log(`每页 ${val} 条`);
    },
    /**
     * 监测当前页数变化
     * @param val
     */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.findCustomerCount();
      // console.log(`当前页: ${val}`);
    },

    /**
     * 删除客户信息
     * @param row  行数据
     */
    handleDelete(row) {
      this.$http.get("https://yuanteng.tech:8081/customer/delete?id=" + row.id).then(res => {
        if (res.data.status) {
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
          this.find();
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    //删除 操作确认弹出框
    open(row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelete(row);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //修改用户信息
    handleUpdate(row) {
      // console.log(row);
      this.dialogFormVisible = true;
      this.find();
      this.form = row;
      this.$nextTick(() => {
        this.$refs['form'].resetFields();
      });
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.dialogFormVisible = false;
          this.$http.post("https://yuanteng.tech:8081/customer/update", this.form).then(res => {
            if (res.data.status) {
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
              this.find();
            } else {
              this.$message.error(res.data.msg);
            }
          }).finally(() => {
            this.loading = false
          });
        }
      });
    },
    /**
     * 监测el-dialog关闭：清除upload里面的内容
     */
    closeDialog() {
      this.$refs.upload.clearFiles();
    },
    /**
     * 点击 取消 关闭el-dialog：如果有上传的图片则删除
     */
    close() {
      this.dialogFormVisible = false;
      if (this.form.evidence != null) {
        let length = this.form.evidence.length;
        for (let i = 0; i < length; i++) {
          this.$http.post("https://yuanteng.tech:8081/file/delete", this.form.evidence[i]).then(res => {
          })
        }
      }
    },

    handleResize() {
      if (window.innerWidth < 768) {
        this.labelPosition = "top";
        this.handleWidth = 50;
      } else {
        this.labelPosition = 'right';
        this.handleWidth = 92;
      }
    },
    /**
     * 查看上传未提交时的图片
     * @param file
     */
    handlePicturePreview(file) {
      this.dialogImageUrl = file.response.msg;
      this.dialogVisible = true;
    },
    //查看大图
    handlePictureCardPreview(fileUrl) {
      this.dialogImageUrl = fileUrl;
      this.dialogVisible = true;
    },
    /**
     * 上传图片
     * @param res
     * @param file
     * @param fileList
     */
    handleEvidenceSuccess(res, file, fileList) {
      if (res.status) {
        if (fileList.every(item => item.status == "success")) {
          this.form.evidence = fileList.map(value => value.response.msg);
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeEvidenceUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('仅支持jpeg/png/jpg图片类型');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    /**
     *  删除图片
     * @param file
     * @param fileList
     */
    handleRemove(file, fileList) {
      if (file) {
        this.$http.post("https://yuanteng.tech:8081/file/delete", file.response.msg).then(res => {
          if (res.data && this.form.evidence.length != 0) {
            for (let i = 0; i < this.form.evidence.length; i++) {
              if (this.form.evidence[i] == (file.response.msg)) {
                this.form.evidence.splice(i, 1);
              }
            }
          }
        })
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    /**
     * 图片移除前的确认
     * @param file
     * @param fileList
     * @returns {Promise<MessageBoxData>}
     */
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  },
  created() {
    this.user = JSON.parse(window.localStorage.getItem('access-admin'))
    this.userRole = decodeURIComponent(window.atob(this.user.role)) == "ADMIN"
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>
.el-main {
  padding-top: 10px;
}

.el-button {
  margin-bottom: 15px;
}

.el-divider {
  margin-bottom: 2px;
}

/deep/ .el-dialog {
  margin-top: 5vh !important;
}

.el-form {
  max-width: 400px;
}

/deep/ .el-table .warning-row {
  background: oldlace;
}

.main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.search {
  display: flex;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.pagination2 {
  margin-top: 20px;
  text-align: right;
  display: none;
}

/*修改图片*/
/deep/ .evidence-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.evidence-uploader .el-upload:hover {
  border-color: #409EFF;
}

.evidence-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
}

.evidence {
  width: 128px;
  height: 128px;
  display: block;
}

@media screen {
  /deep/ .el-form--label-top .el-form-item__label {
    padding: 0 !important;
  }
}

@media screen and (max-width: 768px) {
  .pagination {
    display: none;
  }

  .pagination2 {
    display: block;
  }

  /deep/ .el-form-item {
    margin-bottom: 8px;
  }

  /deep/ .el-dialog {
    width: 70% !important;
  }

  .el-form {
    max-width: 300px;
  }

  /deep/ .el-button + .el-button, .el-checkbox.is-bordered + .el-checkbox.is-borderedn {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FindCustomer.vue